export interface FAQItem { question: string; answer: string; }

export const faqContent: FAQItem[] = [
  {
    question: 'Is Parsant a consultancy or a build shop?',
    answer:
      'Both, in one engagement. We bring the revenue strategy, then build the layer that runs it alongside your team. We do not take an interim executive role and we do not manage the sales team.',
  },
  {
    question: 'What does an engagement actually cost?',
    answer:
      'Plan is $15K to $30K and runs 2 to 4 weeks. Embed is $15K to $25K per month over 3 to 6 months. Hand-off is $15K to $30K and runs 1 to 2 months. A typical 12-month sequence lands between $75K and $210K. Every mode is a fixed scope with a fixed number. You know the cost before the work starts.',
  },
  {
    question: 'Who actually does the work?',
    answer:
      'A single senior Parsant operator runs every engagement and is on every call, with contract engineering added per project. The roster stays short on purpose, so whoever scoped the engagement is still running it at Hand-off. A company that needs a full-time revenue executive is hiring for a different role than this one.',
  },
  {
    question: 'Does our team learn to run this after Parsant leaves?',
    answer:
      'Yes. We name the internal owner in week one, and they sit in the definitions reviews and work the forecast and pipeline tooling with us. They run the system in shadow mode before Hand-off. After Hand-off, they own it outright.',
  },
  {
    question: 'What if our environment is regulated, like healthcare, finance, or FDA?',
    answer:
      'That is where Parsant is sharpest. Every Plan includes a compliance review, and builds are scoped so regulated data stays inside your existing controls. The audit trail is part of the deliverable. Expect 1 to 2 weeks of legal review on top of the Plan timeline if BAAs, MSAs, or vendor security reviews are required.',
  },
  {
    question: 'What technology stack does Parsant use?',
    answer:
      'We deploy inside your stack, which means the CRM, the marketing automation platform, the data warehouse, and whatever runs the pipeline and forecast today. When the existing stack cannot support what needs to ship, we recommend specific additions case by case, with a written rationale before any commitment. The prompt and evaluation layer stays separate from the model call, so swapping the underlying model later is a configuration change.',
  },
  {
    question: 'How is this different from hiring an advisor?',
    answer:
      'An advisor leaves a plan and a team to manage. We leave a working system, with the exit signed before close. The strategy and the build come from the same party, which is the only way the definitions survive contact with the tracking.',
  },
  {
    question: 'How is this different from an automation or GTM-engineering vendor?',
    answer:
      "Those firms build to someone else's spec. We bring the spec, so the map, the definitions, and the roadmap come first and the automation gets built against the step that is actually holding throughput up. Hiring strategy and build separately usually costs more than Embed and leaves two parties who have to agree before anything ships.",
  },
  {
    question: 'Who is Parsant for, and who is it not for?',
    answer:
      'Operators in regulated markets, PE-backed or growth-stage, most often in healthcare and financial services. Not a fit for a pre-revenue company, for a first sales hire, or for a tool rollout with no executive mandate behind it.',
  },
];
